// cSpell: words Slardar
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function report(level, message, tags) {
    var extra = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        extra[_i - 3] = arguments[_i];
    }
    var str = "";
    try {
        str = JSON.stringify(extra);
    }
    catch (e) {
        str = e.toString();
    }
    Object.keys(tags).forEach(function (key) {
        if (typeof tags[key] !== "string") {
            try {
                tags[key] = JSON.stringify(tags[key]);
            }
            catch (e) {
                //
            }
        }
    });
    var log = {
        value: "[".concat(level, "] ").concat(message, "\n extra: ").concat(str),
        tags: __assign(__assign({}, (tags || {})), { level: level }),
    };
    if (window.Slardar) {
        window.Slardar("emit", "log", log);
        window.Slardar("emit", "counter", {
            name: tags.type,
            value: 1,
            tags: __assign(__assign({}, (tags || {})), { level: level }),
        });
    }
}
export function reportError(error, tags) {
    var extra = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        extra[_i - 2] = arguments[_i];
    }
    report.apply(void 0, __spreadArray(["error", error, tags], extra, false));
}
export function reportWarn(warn, tags) {
    var extra = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        extra[_i - 2] = arguments[_i];
    }
    report.apply(void 0, __spreadArray(["warn", warn, tags], extra, false));
}
export function reportInfo(info, tags) {
    var extra = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        extra[_i - 2] = arguments[_i];
    }
    report.apply(void 0, __spreadArray(["info", info, tags], extra, false));
}
export function fetchError(url, data, message) {
    reportError(url, {
        type: "fetch",
        message: message,
        url: url
    }, data);
}
export function reportRequestBefore(url) {
    reportInfo(url, {
        type: "fetch",
        message: "request before",
        url: url
    });
}
export function reportRequestAfter(url) {
    reportInfo(url, {
        type: "fetch",
        message: "request after",
        url: url
    });
}
export function reportRetryFail(url, message) {
    reportError(url, {
        type: "Request-retry-fail",
        message: "request retry fail: ".concat(message),
        url: url
    });
}
report.error = reportError;
report.warm = reportWarn;
report.info = reportInfo;
report.reportRequestBefore = reportRequestBefore;
report.reportRequestAfter = reportRequestAfter;
report.reportRetryFail = reportRetryFail;
export default report;
//# sourceMappingURL=index.js.map